import {
  EMessageType,
  IGameStartedMessage,
  IInfoMessage,
  ILeaderboardMessage,
} from '@/types/ws.types'
import {ESprintenTeam} from '@repo/shared/Customer/Coop/SprintenTeams/SprintenTeams.types'
import {IEndPositionsState} from '../Store/atoms'

export const generateInfoMessage = (): IInfoMessage => {
  return {
    game: 'S',
    gameCode: 0,
    hasStarted: false,
    hash: '-',
    playerCount: 1,
    serverTime: Date.now(),
    teams: [
      ESprintenTeam.Anglamark,
      ESprintenTeam.CoopMega,
      ESprintenTeam.CoopPrix,
      ESprintenTeam.Extra,
      ESprintenTeam.OBS,
    ],
    type: EMessageType.Info,
  }
}

/**
 * Leaderboard message
 */
interface IGenerateLeaderboard {
  team: ESprintenTeam
  clicks: number
  percentage: number
}

export const generateLeaderboardMessage = ({
  team,
  clicks,
  percentage,
}: IGenerateLeaderboard): ILeaderboardMessage => ({
  leaderboard: [],
  leaderboardTeams: [{clicks, percentage, slot: 1, team, playerCount: 1}],
  totalClients: 1,
  totalTeams: 1,
  type: EMessageType.Leaderboard,
})

/**
 * Game started message
 */
export const generateGameStartedMessage = (countdownFromSeconds: number): IGameStartedMessage => {
  const startTime = Date.now() + countdownFromSeconds * 1000

  return {
    countdownFromSeconds,
    startTime,
    type: EMessageType.GameStarted,
  }
}

/**
 * End position message
 */
export const generateEndPositionMessage = (team: ESprintenTeam): IEndPositionsState => {
  return {position: 1, slot: 1, team, type: EMessageType.EndPosition, teamEndTimestamp: Date.now()}
}

/**
 * Game ended message
 */
// export const generateGameEndedMessage = (team: ESprintenTeam): IGameEndedMessage => {
//   return {winner: team, type: EMessageType.GameEnded}
// }
